"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function Pause(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 128 128", preserveAspectRatio: "xMidYMid" }, props),
        React.createElement("path", { d: "M41.86 128V0H8.648v128h33.21zm77.491 0V0h-33.21v128h33.21z", fill: "currentColor" })));
}
exports.default = Pause;
//# sourceMappingURL=Pause.js.map